import { IKakaoPayBookInfo, KakaoPayBookInfo } from "@/domain/entities/book";
import { ParseError } from "@/repositories/shared/errors/parseError";
import { Result, err, ok } from "neverthrow";
import { HttpKakaoPayBook, IKakaoPayBookParser } from "../bookRepository.types";
import { injectable } from "inversify";

@injectable()
export class KakaoPayBookParser implements IKakaoPayBookParser {
  constructor() {}

  toDomain(data: HttpKakaoPayBook): Result<IKakaoPayBookInfo, ParseError> {
    try {
      const bookInfo: IKakaoPayBookInfo = {
        id: data.bookUid,
        totalAmount: data.totalAmount,
        mobileRedirectUrl: data.nextRedirectMobileUrl,
        pcRedirectUrl: data.nextRedirectPcUrl,
      };
      const kakaoPayBookInfo = new KakaoPayBookInfo(bookInfo);
      return ok(kakaoPayBookInfo);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
